import { Link } from "react-router-dom";
import LegalPageLayout from "../../layout/LegalPageLayout";

function CookiePolicyPage() {
  return (
    <LegalPageLayout title="Politika kolačića">
      <p>
        Kako bi ova web stranica radila pravilno te kako bismo bili u stanju
        vršiti daljnja unaprjeđivanja stranice, u svrhu poboljšavanja Vašega
        iskustva pregledavanja, ova stranica mora na vaše računalo spremiti
        malenu količinu informacija kolačića.
      </p>
      <p>
        Kako biste saznali kako štitimo vašu privatnost prilikom uporabe
        kolačića pročitajte Pravila o privatnosti (
        <Link to="/politika-privatnosti">
          https://www.lumenathome.com/politika-privatnosti
        </Link>
        ).
      </p>

      <h5>1. Što su kolačići?</h5>
      <p>
        Kolačić je kratak tekst koji web stranica šalje vašem pregledniku. Web
        stranica putem kolačića pamti vaše radnje i željene postavke (prijava,
        sadržaj košarice, veličina fonta i druge postavke povezane s izgledom)
        tijekom duljeg razdoblja. Svi kolačići imaju datume isteka koji određuju
        koliko dugo ostaju u vašem pregledniku. Kolačiće možete kontrolirati u
        bilo kojem trenutku, što znači da ih možete obrisati. U nastavku smo
        uključili više pojedinosti kako bismo vam objasnili koje vrste kolačića
        koristimo.
      </p>

      <h5>2. Koje kolačiće koristimo?</h5>
      <p>Lumen koristi tehničke, funkcionalne i statističke kolačiće.</p>
      <p>Pregled korištenih kolačića:</p>

      <p>
        <strong>Tehnički kolačići:</strong>
      </p>
      <table>
        <thead>
          <tr>
            <th>Ime</th>
            <th>Opis</th>
            <th>Trajanje</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>refreshToken</td>
            <td>Pohranjuje token za autentifikaciju korisnika</td>
            <td>Trajno</td>
          </tr>
          <tr>
            <td>accessToken</td>
            <td>Pohranjuje token za autentifikaciju korisnika</td>
            <td>Trajno</td>
          </tr>
        </tbody>
      </table>

      <p>
        <strong>Funkcionalni kolačići:</strong>
      </p>
      <table>
        <thead>
          <tr>
            <th>Ime</th>
            <th>Opis</th>
            <th>Trajanje</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>userProfile</td>
            <td>
              Podaci korisnika koji se čuvaju na korisnikovom web pregledniku
              kako bi se ubrzao rad web aplikacije
            </td>
            <td>Trajno</td>
          </tr>
        </tbody>
      </table>

      <p>
        <strong>Statistički kolačići:</strong>
      </p>
      <table>
        <thead>
          <tr>
            <th>Ime</th>
            <th>Opis</th>
            <th>Trajanje</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>_ga</td>
            <td>
              Koristi se za razlikovanje posjetitelja i davanje jedinstvenog
              identifikatora svakom posjetitelju, za prikupljanje informacija o
              posjetiteljima web stranice, uključujući anonimne podatke o broju
              posjetitelja, vremenu provedenom na web stranici, pregledanim
              stranicama itd. Ovi podaci pomažu vlasnicima web stranica
              analizirati izvedbu web stranice i prilagoditi sadržaj za
              poboljšanje iskustva posjetitelja.
            </td>
            <td>2 godine</td>
          </tr>
        </tbody>
      </table>

      <p>
        <strong>Što su tehnički kolačići?</strong>
      </p>
      <p>
        Svrha tehničkih kolačića je omogućiti ispravno i učinkovito
        funkcioniranje web stranice i zapamtiti vaš unos kako bi se olakšalo
        korištenje web stranice. Ako se tehnički kolačići onemoguće, web
        stranica će otežano funkcionirati. Iz tog razloga ih nije dopušteno
        onemogućiti.
      </p>
      <p>
        <strong>Što su funkcionalni kolačići?</strong>
      </p>
      <p>
        Svrha funkcionalnih kolačića je omogućiti poboljšanu funkcionalnost i
        personalizaciju web stranice.
      </p>
      <p>
        <strong>Što su statistički kolačići?</strong>
      </p>
      <p>
        Svrha statističkih kolačića je prikupljati informacije o tome kako
        posjetitelj posjećuje web stranicu.
      </p>
      <p>
        <strong>Što su kolačići prve strane?</strong>
      </p>
      <p>
        Kolačići od prve strane nadzire Lumen, a mogu biti stalni ili
        privremeni. Pomoću tih kolačića web stranice mogu pohraniti podatke koje
        će ponovo koristiti prilikom sljedećeg posjeta tim web stranicama.
      </p>
      <p>
        <strong>Što su privremeni kolačići?</strong>
      </p>
      <p>
        Privremeni kolačići ili kolačići sesije uklanjaju se s računala ili
        mobitela po zatvaranju web preglednika. Pomoću njih web stranice
        pohranjuju privremene podatke.
      </p>
      <p>
        <strong>Što su stalni kolačići?</strong>
      </p>
      <p>
        Stalni kolačići ostaju na računalu ili mobitelu nakon zatvaranja
        programa internet preglednika, sve dok se ne obrišu. Pomoću njih web
        stranice pohranjuju podatke, kao što su ime za prijavu i korisnički
        token za autentifikaciju, tako da se ne morate prijavljivati prilikom
        svakog posjeta određenom mjestu.
      </p>
      <p>
        Lumen koristi anonimizirane kolačiće koji vas ne identificiraju, s
        primarnim ciljem ispravnim funkcioniranjem naše web stranice.
      </p>
      <p>
        <strong>Što su kolačići treće strane i koristimo li ih?</strong>
      </p>
      <p>
        Za razliku od kolačića prvih strana, koji su postavljeni izravno od
        strane web stranice koju posjećujete, kolačići trećih strana dolaze od
        domene koja nije web stranica koju trenutno pregledavate. Ovi kolačići
        omogućuju trećim stranama, poput oglašivačkih mreža ili analitičkih
        servisa, da prate vaše online ponašanje preko različitih web stranica.
        Lumen koristi određene Googleove usluge temeljem kojih putem kolačića
        Google prikuplja i određene osobne podatke - Google Analytics kao servis
        za mjerenje posjećenosti.
      </p>

      <p>
        <strong>Korištenje Google Analytics kolačića</strong>
      </p>
      <p>
        Google Analytics je analitički alat koji pomaže vlasnicima web stranica
        da saznaju kako njihovi posjetitelji koriste opcije njihovih stranica i
        aplikacija. Google Analytics može koristiti skup kolačića za
        prikupljanje informacija i izvješćivanje o statistici korištenja
        stranice tako da zadrži anonimnim identitet posjetitelja. Glavni kolačić
        Google Analyticsa je "_ga".
      </p>
      <p>
        Google Analytics se može koristiti i za prikaz relevantnijih oglasa na
        Google proizvodima (kao što je Google search) i na internetu te za
        mjerenje interakcija s oglasima prikazujemo.
      </p>
      <p>
        Saznajte više na{" "}
        <a
          href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=en_US"
          target="_blank"
          rel="noreferrer"
        >
          developers.google.com/analytics
        </a>
        .
      </p>

      <p>
        <strong>
          Izvoz i brisanje podataka prikupljenih putem kolačića pomoću
          Googleovih usluga
        </strong>
      </p>
      <p>
        U bilo kojem trenutku možete izvesti kopiju svojih podataka ili ih
        izbrisati sa svog Google računa.
      </p>
      <p>Da biste izbrisali svoje podatke, možete:</p>
      <ul>
        <li>
          Izbrisati određene aktivnosti pojedinačno ili grupno preko stranice{" "}
          <a
            href="https://myactivity.google.com/myactivity?pli=1"
            target="_blank"
            rel="noreferrer"
          >
            Moja aktivnost
          </a>
        </li>
        <li>
          Izbrisati određene Google usluge kao Gmail ili podataka povezanih s
          njima
        </li>
        <li>Izbrisati cijeli Google račun u postavkama vašeg Google računa</li>
      </ul>
      <p>
        Ako imate pitanja ili nejasnoća možete se obratiti Googleu i njihovom
        uredu za zaštitu privatnosti, a možete se obratiti i Agenciji za zaštitu
        osobnih podataka u Republici Hrvatskoj.
      </p>

      <h5>3. Kako možete upravljati kolačićima?</h5>
      <p>
        Upravljanje kolačićima kroz postavke preglednika omogućuje vam da
        kontrolirate kako se kolačići pohranjuju i koriste na vašim uređajima. U
        bilo kojem trenutku možete promijeniti svoje preferencije u postavkama
        preglednika kojeg koristite kao i izbrisati kolačiće. Da biste izbrisali
        sve pohranjene kolačiće, u odjeljku za privatnost i sigurnost svog
        preglednika pronađite opciju koja omogućuje brisanje povijesti
        pregledavanja ili pohranjenih podataka. Možete odabrati da izbrišete sve
        kolačiće ili samo one određene stranice. Za detaljnije upravljanje
        kolačićima, možete instalirati dodatke ili proširenja koja nude
        poboljšane opcije za kontrolu kolačića, poput blokiranja tracker-a ili
        automatskog čišćenja kolačića nakon svake sesije pregledavanja.
      </p>

      <h5>4. Izmjena Politike kolačića</h5>
      <p>
        Lumen zadržava pravo izmjene ove Politike kolačića u bilo kojem
        trenutku. Lumen će izmijeniti Politiku kolačića u slučaju promjene
        kolačića navedenih u Politici i po potrebi zatažiti novu privolu od
        Ispitanika najkasnije u roku od 7 dana od nastanka okolnosti koje su
        dovele do promjene u ovim Politikama.
      </p>
      <p>
        Našeg voditelja obrade podataka možete kontaktirati na email:{" "}
        <a href="mailto:k_bljaic@yahoo.com">k_bljaic@yahoo.com</a>, telefon:{" "}
        <a href="tel:+38598482065">+385 98 482 065</a> ili poštom na Obrt za
        poduke LUMEN Rijeka, Fiorella la Guardia 12, Rijeka.
      </p>
    </LegalPageLayout>
  );
}

export default CookiePolicyPage;
